import { render, staticRenderFns } from "./CreateOrUpdateActivityForm.vue?vue&type=template&id=8da05acc&scoped=true"
import script from "./CreateOrUpdateActivityForm.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateActivityForm.vue?vue&type=script&lang=js"
import style0 from "./CreateOrUpdateActivityForm.vue?vue&type=style&index=0&id=8da05acc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da05acc",
  null
  
)

export default component.exports